import type { SkincareFormatPicker } from 'types/cms/blocks';
import { PurchaseType } from 'types/product/PurchaseType';

import type { ProductCtasProps } from '../ProductCtas';

export const mapSkincareFormatPickerToCtas = (
  skincareFormatPicker: SkincareFormatPicker,
): Omit<ProductCtasProps, 'colorScheme'> => {
  const { product, variant } = skincareFormatPicker.productFormats[0];

  return {
    blockId: skincareFormatPicker._key,
    promoCodes: skincareFormatPicker.promoCodes,
    purchaseType: PurchaseType.OTP,
    isDiscountHidden: skincareFormatPicker.isDiscountHidden,
    product: {
      slug: product.slug,
      variants: [variant],
    },
  };
};
